import { defineApi } from '@/utils/fetch';

import type { IAuthLoginResponseData, IAuthLogoutResponseData, IPostAuthLoginData } from './typings';

export const AuthApi = {
    postLogin: defineApi<IPostAuthLoginData, IAuthLoginResponseData>({
        url: '/auth/login/v1',
        method: 'POST',
    }),
    postLogout: (device_id: string) => {
        const api = defineApi<undefined, IAuthLogoutResponseData>({
            url: '/user/out/v1',
            method: 'POST',
            query: {
                device_id,
            },
        });
        return api();
    },
};

export * from './typings';
